























































































































































































import { germanZipRule } from "@/lib/rules/contactRule";
import { beforeCurrentDateRule, dateRule } from "@/lib/rules/dateRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import { CreateChargingStation } from "@/store/models/thg/create-charging-station";
import { ChargingPointConnector, ChargingPointType } from "@/store/models/thg/create-charging-point";
import { CreateChargingStationOperator } from "@/store/models/thg/create-charging-station-opereator";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue, Watch } from "vue-property-decorator";
import { isNumberRule } from "@/lib/rules/isNumberRule";

@Component({
  components: {}
})
export default class ThgChargingStationForm extends Vue {
  chargingStation = new CreateChargingStation();
  chargingPointOperator = new CreateChargingStationOperator();

  isCompany = false;
  isResubmittingTaxnumber = false;
  taxnumber = "";

  isDatepickerMenuActive = false;
  activePicker = "YEAR";

  valid = false;

  get isRegisteredItems() {
    return [
      { text: this.$t("components.thg.ThgChargingStationForm.isCompany.true"), value: true },
      { text: this.$t("components.thg.ThgChargingStationForm.isCompany.false"), value: false }
    ];
  }
  get germanZipRule() {
    return [germanZipRule(), requiredRule()];
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get dateRule() {
    return [dateRule(), beforeCurrentDateRule()];
  }

  get numberRule() {
    return [isNumberRule(), requiredRule()];
  }

  get chargingPointTypes() {
    return ChargingPointType;
  }

  get chargingPointConnector() {
    return ChargingPointConnector;
  }

  mounted() {
    this.chargingPointOperator = CreateChargingStationOperator.createFromUser(UserModule.user);
  }

  @Watch("isDatepickerMenuActive")
  menu(val: boolean) {
    return val && setTimeout(() => (this.activePicker = "YEAR"));
  }

  save() {
    this.chargingStation.chargingPointOperator = this.chargingPointOperator;

    this.$emit("save", this.chargingStation);
  }
}
